import "bootstrap/dist/css/bootstrap.min.css";
import ChatbotButton from "../../components/common/ChatbotButton";
import "../../assets/styles/Sports.css";
import { useContext, useEffect, useState, useCallback } from "react";
import { MyActivitiesAPI, AllActivitiesAPI } from "../../services/userService"; // استيراد الفانكشن
import { AuthContext } from "../../context/AuthContext.js";
import ActivityCard from "../../components/ui/newActivityCard.js";
import FullPageLoader from "../../components/ui/fullPageLoader.js";
import Skeleton from "react-loading-skeleton"; // استيراد مكتبة الـ Skeleton
import debounce from "lodash.debounce"; // استيراد مكتبة الـ Debounce
import { userRoles } from "../../App.js";

export default function MyActivity() {
  const { loading, user } = useContext(AuthContext);
  const [activities, setActivities] = useState([]);
  const [loadingApi, setLoadingApi] = useState(false);
  const [page, setPage] = useState(1); // إدارة الصفحة
  const [statusFilter, setStatusFilter] = useState("ACTIVE"); // إدارة الفلتر
  const [totalCount, setTotalCount] = useState(0); // عدد الأنشطة الإجمالي
  const [statusCount, setStatusCount] = useState({}); // عدد الأنشطة الإجمالي
  
  // استخدام useCallback لضمان عدم إعادة تعريف الدالة عند كل رندر
  // const fetchData = useCallback(async () => {
  //   try {
  //     setLoadingApi(true);
  //     if(user.role === userRoles.admin){
  //       // AllActivitiesAPI
  //     }else{
  //       // MyActivitiesAPI
  //     }
  //     const res = await MyActivitiesAPI(page, 3, statusFilter); // إرسال الصفحة والفلتر
  //     setActivities(res.activities || []);
  //     setTotalCount(res.totalCount || 0); // تحديث العدد الإجمالي
  //     setLoadingApi(false);
  //   } catch (error) {
  //     setLoadingApi(false);
  //     console.error("Error fetching activities:", error);
  //   }
  // }, [page, statusFilter]); // إضافة التبعيات التي إذا تغيرت ستؤدي لإعادة تعريف الدالة

  const fetchData = useCallback(async () => {
    try {
      setLoadingApi(true);

      // let res; // 1. بنعرف المتغير هنا عشان يبقى متاح

      if (user?.role === userRoles.admin) {
        // 2. لو أدمن، ننده الـ API بتاعة الكل
        // افترضت إنها بتاخد نفس الباراميترز (صفحة، عدد، فلتر)
        const res = await AllActivitiesAPI(page, 3, statusFilter);
        setActivities(res.activities || []);
        setTotalCount(res.totalCount || 0);
        setStatusCount(res.statusCount || {});
      } else {
        // 3. لو طالب، ننده الـ API بتاعة الطالب
        const res = await MyActivitiesAPI(page, 3, statusFilter);
        setActivities(res.activities || []);
        setTotalCount(res.totalCount || 0);
        setStatusCount(res.statusCount || {});
      }

      // 4. هنا بنتعامل مع النتيجة (res) اللي رجعت أياً كان مصدرها
    } catch (error) {
      console.error("Error fetching activities:", error);
      // ممكن هنا تظهر رسالة خطأ للمستخدم
    } finally {
      // 5. الـ finally بتشتغل في الحالتين (نجاح أو فشل) عشان نوقف التحميل
      setLoadingApi(false);
    }
  }, [page, statusFilter, user.role]);
  useEffect(() => {
    fetchData();
  }, [fetchData]); // الآن نقوم بإضافة fetchData إلى الـ dependencies

  // تحسين الفلتر باستخدام debounce
  const debouncedFilterChange = debounce((newFilter) => {
    setStatusFilter(newFilter);
  }, 500); // تأخير نصف ثانية

  if (loading) {
    return <FullPageLoader loadingName="Loading user..." />;
  }

  // حساب عدد الصفحات
  const totalPages = Math.ceil(totalCount / 3);

  return (
    <div
      className="myactivities-container container py-5"
      style={{ marginTop: "50px" }}
    >
      <div className="container py-5">
        <div className="text-center mb-4">
          <h1 className="fw-bold text-primary mb-2">My Activities</h1>
          <p className="text-secondary">
            Explore your activities and manage your registrations.
          </p>
        </div>

        {/* فلتر الحالة - باستخدام الأزرار */}
        <div className="filter-section text-center mb-4">
          <div
            className="btn-group"
            role="group"
            aria-label="Activity Status Filter"
          >
            <button
              className={`btn btngroup ${statusFilter === "ACTIVE" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => debouncedFilterChange("ACTIVE")}
            >
              Active '{statusCount.totalActiveCount}'
            </button>
            <button
              className={`btn btngroup ${statusFilter === "PENDING" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => debouncedFilterChange("PENDING")}
            >
              Pending '{statusCount.totalPendingCount}'
            </button>
            <button
              className={`btn btngroup ${statusFilter === "FINISHED" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => debouncedFilterChange("FINISHED")}
            >
              Finished '{statusCount.totalFinishedCount}'
            </button>
            <button
              className={`btn btngroup ${statusFilter === "CANCELLED" ? "btn-primary" : "btn-outline-primary"}`}
              onClick={() => debouncedFilterChange("CANCELLED")}
            >
              Cancelled '{statusCount.totalCancelledCount}'
            </button>
          </div>
        </div>

        {/* الأنشطة */}
        <div className="row justify-content-center g-4">
          {loadingApi && (
            <>
              {[...Array(6)].map((_, index) => (
                <div key={index} className="col-12 col-md-6 col-lg-4">
                  <Skeleton
                    height={200}
                    containerClassName="skeleton-container"
                  />
                </div>
              ))}
            </>
          )}

          {!loadingApi && activities.length === 0 && (
            <div className="col-12 text-center">
              <p className="text-danger">
                No activities found for the selected filter.
              </p>
            </div>
          )}

          {/* عرض الأنشطة */}
          {!loadingApi &&
            activities.map((activity) => (
              <div key={activity?._id} className="col-12 col-md-6 col-lg-4">
                <ActivityCard
                  _id={activity?._id}
                  activityName={activity?.activityName}
                  posterImage={activity?.posterImage}
                  capacity={activity?.capacity}
                  participantsCount={activity?.participantsCount}
                  supervisorID={activity?.supervisorID}
                  participants={activity?.participants}
                  currentUserId={user?._id}
                  role={user?.role}
                  flags={activity?.flags}
                  type={activity?.type}
                />
              </div>
            ))}
        </div>

        {/* الباجينيشن */}
        <div className="pagination-section text-center mt-4">
          <button
            className="btn btn-primary"
            onClick={() => setPage((prevPage) => Math.max(prevPage - 1, 1))}
            disabled={page === 1}
          >
            Previous
          </button>
          <span className="mx-2">Page {page}</span>
          <button
            className="btn btn-primary"
            onClick={() =>
              setPage((prevPage) => Math.min(prevPage + 1, totalPages))
            }
            disabled={page === totalPages || totalPages === 0}
          >
            Next
          </button>
        </div>
      </div>

      <ChatbotButton />
    </div>
  );
}
